import { AnimatedSprite, Container, Spritesheet } from "pixi.js";
import { PromiseCompletionSource } from "../../../../../../shared/async/PromiseCompletionSource";

export class TargetExplosionView extends Container {
    public static readonly EXPLOSION_DURATION: number = 100/*ms*/;
    private static readonly ANIMATION_SCALE = 4;
    private static readonly ANIMATION_SPEED = 2;

    private readonly vcs: PromiseCompletionSource<void>;

    private animatedSprite: AnimatedSprite;
    public isActive: Boolean;

    public constructor(spritesheet: Spritesheet) {
        super();
        this.vcs = new PromiseCompletionSource();
        this.animatedSprite = new AnimatedSprite(spritesheet.animations.strike);
        this.animatedSprite.animationSpeed = TargetExplosionView.ANIMATION_SPEED;
        this.animatedSprite.scale.set(TargetExplosionView.ANIMATION_SCALE, TargetExplosionView.ANIMATION_SCALE);
        this.animatedSprite.anchor.set(0.5, 1);
        this.animatedSprite.onComplete = this.onAnimationEnd.bind(this);
        this.addChild(this.animatedSprite);
        this.animatedSprite.loop = false;
    }

    private onAnimationEnd(): void {
        this.animatedSprite.currentFrame = 0;
        this.vcs.complete();
        this.isActive = false;
    }

    public finishProgress(): void {
        this.animatedSprite.currentFrame = this.animatedSprite.totalFrames - 1;
    }

    public async play(): Promise<void> {
        this.animatedSprite.play();
        this.isActive = true;
        await this.vcs.result;
    }

    public stop(): void {
        this.animatedSprite.animationSpeed = 0;
    }

    public async continue(): Promise<void> {
        this.animatedSprite.animationSpeed = TargetExplosionView.ANIMATION_SPEED;
        await this.vcs.result;
    }
}
